import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Eye } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "usl_admin_token";
const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY) || ""}` });

export default function Broadcast() {
  const [form, setForm] = useState({ subject: "", body: "", region_contains: "" });
  const [loading, setLoading] = useState(false);

  const send = async (testOnly) => {
    if (!form.subject.trim() || !form.body.trim()) { toast.error("Subject and body required"); return; }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/watch/broadcast`, {
        subject: form.subject,
        body: form.body,
        region_contains: form.region_contains || null,
        test_only: testOnly,
      }, { headers: authHeader() });
      toast.success(testOnly ? "Test email queued — check inbox in ~30s" : `Broadcast queued to ${data.queued} watcher${data.queued === 1 ? "" : "s"}`);
    } catch { toast.error("Send failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="space-y-6">
      <div className="bg-[#11171A] border border-[#F4EFE6]/10 p-8 space-y-6">
        <div className="overline">Compose broadcast</div>
        <div>
          <label className="overline block mb-2">Subject *</label>
          <input data-testid="broadcast-subject" className="underline-input" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} placeholder="Planning update for your area" />
        </div>
        <div>
          <label className="overline block mb-2">Region filter (optional)</label>
          <input data-testid="broadcast-region" className="underline-input" value={form.region_contains} onChange={(e) => setForm({ ...form, region_contains: e.target.value })} placeholder="e.g. Cotswolds — leave blank to send to all active watchers" />
        </div>
        <div>
          <label className="overline block mb-2">Body (Markdown — **bold**, ## headings, - bullets)</label>
          <textarea data-testid="broadcast-body" rows={14} className="underline-input resize-y" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} style={{ fontFamily: 'ui-monospace, monospace', fontSize: '13px', lineHeight: '1.6' }} placeholder={"## Update from Upsurge\n\nThe **5-year housing land supply** in your area has been challenged...\n\n- Point one\n- Point two\n\nKind regards, the Upsurge team"} />
        </div>
        <div className="flex gap-3">
          <button data-testid="broadcast-test" onClick={() => send(true)} disabled={loading} className="usl-btn-outline text-xs"><Eye size={14} /> Send test to me first</button>
          <button data-testid="broadcast-send" onClick={() => send(false)} disabled={loading} className="usl-btn text-xs"><Send size={14} /> Broadcast to watchers</button>
        </div>
        <p className="text-xs text-[#9BA39B]">
          A broadcast sends to every <strong>active</strong> watcher matching your region filter. Each email includes a one-click unsubscribe link. Always send a test to yourself first.
        </p>
      </div>
    </div>
  );
}
